import { axiosInstance } from '~/services';

import type { TypePostUserFindIdParams } from '~/types/auth.types';
import type { TypeErrorResponseData } from '~/types/common.types';

const usePostUserFindId = () => {
  const endPoint = '/api-owner/user/find/id';

  const postUserFindId = async (params: TypePostUserFindIdParams) => {
    return axiosInstance
      .post(endPoint, {
        ownerCode: params.ownerCode,
        name: params.name,
        email: params.email,
      })
      .then(({ data }) => {
        return data.data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { postUserFindId };
};

export default usePostUserFindId;
